var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70696 7.70711C7.89449 7.51957 8.15562 7.42099 8.43289 7.43304C8.71016 7.4451 8.98087 7.5668 9.18545 7.77139L24.6132 23.1992C24.8178 23.4038 24.9395 23.6745 24.9516 23.9517C24.9636 24.229 24.8651 24.4901 24.6775 24.6777C24.49 24.8652 24.2289 24.9638 23.9516 24.9517C23.6743 24.9397 23.4036 24.818 23.199 24.6134L7.77124 9.1856C7.56665 8.98102 7.44495 8.71031 7.43289 8.43304C7.42084 8.15577 7.51942 7.89464 7.70696 7.70711Z",
    fill: "#030C36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6759 7.70711C24.4883 7.51957 24.2272 7.42099 23.9499 7.43304C23.6727 7.4451 23.4019 7.5668 23.1974 7.77139L7.76958 23.1992C7.56499 23.4038 7.44328 23.6745 7.43123 23.9517C7.41917 24.229 7.51776 24.4901 7.70529 24.6777C7.89283 24.8652 8.15396 24.9638 8.43123 24.9517C8.7085 24.9397 8.9792 24.818 9.18379 24.6134L24.6116 9.1856C24.8162 8.98102 24.9379 8.71031 24.9499 8.43304C24.962 8.15577 24.8634 7.89464 24.6759 7.70711Z",
    fill: "#030C36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseMobile);
export default __webpack_public_path__ + "static/media/ic-close-mobile.f8b7b0eca271c685711e99994596825f.svg";
export { ForwardRef as ReactComponent };